import React from 'react';
import { PaperClipOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styles from '../Chat.module.scss';

interface Props {
  file: File;
  fileTitle: string;
  setFileTitle: (title: string) => void;
  fileUploading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const UploadConfirmCard: React.FC<Props> = ({
  file,
  fileTitle,
  setFileTitle,
  fileUploading,
  onConfirm,
  onCancel,
}) => (
  <div className={styles.uploadConfirmWrapper}>
    <div className={styles.uploadConfirmFile}>
      <PaperClipOutlined className={styles.uploadConfirmIcon} />
      <span className={styles.uploadConfirmName}>{file.name}</span>
    </div>
    <label className={styles.uploadTitleLabel} htmlFor="upload-title">
      Title
      <input
        id="upload-title"
        className={styles.uploadTitleInput}
        value={fileTitle}
        onChange={(e) => setFileTitle(e.target.value)}
        disabled={fileUploading}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onConfirm();
          }
          if (e.key === 'Escape') {
            onCancel();
          }
        }}
        autoFocus
      />
    </label>
    <div className={styles.noteActions}>
      <Button
        className={styles.noteCancelBtn}
        onClick={onCancel}
        disabled={fileUploading}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        className={styles.noteSubmitBtn}
        onClick={onConfirm}
        disabled={fileUploading}
      >
        {fileUploading ? 'Uploading…' : 'Upload'}
      </Button>
    </div>
  </div>
);

export default UploadConfirmCard;
